<div *ngIf="!containsError" class="payment-container">
  <div *ngIf="successMess">
    <div class="successMessAlign">
      <p>
        <li>Payment Change Transaction successfully submitted for Loan No. {{displayLoanNumber}}, effective date: {{displayEffDate | date:"MM/dd/YYYY"}} and
          Payment Term: {{displayPaymentPlan}}</li>
        <li *ngFor="let warningMsg of displayWarningMsg">{{warningMsg}}</li>
      </p>
    </div>
  </div>
  <div>
    <div class="errorMessage " *ngIf="errorMessage.length">
      {{errHeading}}
      <li *ngFor="let message of errorMessage">{{message}}</li>
      <hr class="hrStyle">
    </div>
  </div>
  <div class="notesMess">
    1. Type in the loan number. 2. Type in the effective date. 3. Enter the remaining fields. 4. Click on Submit to submit a transaction.
    5. Click on Clear to clear all the fields. 6. Click on LoanDetail to get the details on the loan.
    7. Click on Transactions to view all the transactions for the loan.
  </div>
  <div class="indicates">
    <span class="EMBRequiredControl">+</span><span class="EMBMessageCue"> Indicates
      required information</span>
  </div>
  <br>
  <div class="ui-g-12">
    <span class="ui-g-5">
      <div class="ui-g-6 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label>Loan Number: </div>
      <div class="ui-g-6"> <input type="text" maxlength="9" [(ngModel)]='loanNumber' maxlength="10"
                                  (keyup)="trackKeyPress($event)" autofocus fmTextInput></div>
    </span>
    <span class="ui-g-5">
      <div class="ui-g-6 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label>Effective Date: </div>
      <div class="ui-g-6">

      <fm-calendar id ="dteffectiveDateFrom" dateFormat="mm/dd/yy" placeholder="&nbsp;MM/DD/YYYY" [(ngModel)]='effDate'
                   [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')"
                   (keyup)="trackKeyPress($event)" [showClear]="true"></fm-calendar>

      </div>
    </span>
  </div>
  <div class="ui-g-12 space-margin-reduction">
    <span class="ui-g-5">
      <div class="ui-g-6 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label>Payment Plan: </div>
      <div class="ui-g-6"> <fm-select [options]="paymentPlans" [(ngModel)]="paymentPlan" ariaLabelledBy="default"></fm-select>
      </div>
    </span>
    <span class="ui-g-5">
      <div class="ui-g-6 lblAlign"> Line of Credit Reserve: </div>
      <div class="ui-g-6"> <input type="text" maxlength="9" [(ngModel)]='lineOfCredit' maxlength="10" (keyup)="trackKeyPress($event)" fmTextInput></div>
    </span>
  </div>
  <div class="ui-g-12 space-margin-reduction">
    <span class="ui-g-5">
      <div class="ui-g-6 lblAlign"> Scheduled Payment: </div>
      <div class="ui-g-6"> <input type="text" maxlength="9" [(ngModel)]='ScheduledPayment' maxlength="10" (keyup)="trackKeyPress($event)" fmTextInput></div>
    </span>
    <span class="ui-g-5">
      <div class="ui-g-6 lblAlign"> Loan Term: </div>
      <div class="ui-g-6"> <input type="text" maxlength="9" [(ngModel)]='loanTerm' maxlength="10" (keyup)="trackKeyPress($event)" fmTextInput></div>
    </span>
  </div>

  <div class="taxes ui-g-12">
    <hr class="hr-tag">
    <div class="ui-g-10 taxes-header glypha-font">
      <label class="taxes-header">Taxes and Insurance</label>
    </div>
  </div>

  <div class="ui-g-12">
      <span class="ui-g-6">
        <div class="ui-g-5 lableright payment-change-tax-container"> <label class="EMBRequiredControl"> </label>Enter an amount: </div>
        <div class="ui-g-5"> <input type="text" maxlength="9" [(ngModel)]='transAmount' maxlength="10" (keyup)="trackKeyPress($event)" fmTextInput></div>
      </span>
    <span class="ui-g-5">
        <div class="ui-g-5 lableright payment-change-tax-container"> <label class="EMBRequiredControl"> </label>or a percentage: </div>
        <div class="ui-g-5"> <input type="text" [(ngModel)]='percentage' maxlength="10" (keyup)="trackKeyPress($event)" fmTextInput></div>
      </span>
  </div>

  <div class="ui-g-12 glypha-font">
    <div class="ui-g-8 space-margin-reduction">
      Withholding Date Range
    </div>
    <div class="ui-g-12 space-margin-reduction">
      <span class="ui-g-5">
        <div class="ui-g-3 lblAlign"> <label class="EMBRequiredControl"> </label>From: </div>
        <div class="ui-g-6">

          <fm-calendar id ="dteffectiveDateFrom" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [(ngModel)]='fromEMBRequiredControl'
                       [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')"
                       (keyup)="trackKeyPress($event)" [showClear]="true"></fm-calendar>

        </div>
      </span>
      <span class="ui-g-5">
        <div class="ui-g-2 lblAlign"> <label class="EMBRequiredControl"> </label>To: </div>
        <div class="ui-g-6">

        <fm-calendar id ="dteffectiveDateFrom" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [(ngModel)]='toEMBRequiredControl'
                     [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')"
                     (keyup)="trackKeyPress($event)" [showClear]="true"></fm-calendar>

        </div>
      </span>
    </div>
  </div>
  <div class="ui-g-12">
    <hr class="hr-tag">
    <span class="ui-g-12">
      <div class="ui-g-4 lblAlign"> <label class="EMBRequiredControl"> </label>Reason for Payment Change: </div>
      <div class="ui-g-5"> <fm-select [options]="reasonForChange" [(ngModel)]="reason" ariaLabelledBy="default"></fm-select></div>
    </span>
  </div>

  <!-- All Buttons -->
  <div class="ui-g-8">
    <button fmButton type="button" [small]="true" label="Clear" (click)="clearBtn()" class="dispbuttonMargin"></button>
    <button fmButton type="button" [small]="true" [primary]="true" label="Submit" (click)="paymentChangeComponent()"
      class="dispbuttonMargin"></button>
    <button fmButton type="button" [small]="true" [primary]="true" label="Loan Detail" (click)="loanDetail()"
      class="dispbuttonMargin"></button>
    <button fmButton type="button" [small]="true" [primary]="true" label="Transactions"
      (click)="showloanDetailWrappers()" class="dispbuttonMargin"></button>
  </div>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
